module.exports = __webpack_public_path__ + "static/img/app4.1c5394fc.png";